import "./hardware-details-page.style.scss";

import { Breadcrumbs, CrumbClickFunc } from "@amzn/stencil-react-components/breadcrumbs";
import { Spinner, SpinnerSize } from "@amzn/stencil-react-components/spinner";
import { View } from "@amzn/stencil-react-components/layout";
import { PageContainer } from "@amzn/stencil-react-components/page";
import { Text } from "@amzn/stencil-react-components/text";
import { PageMainContainer } from "@amzn/it-shop-shared-components";
import { parseTaxonomyIdFromUrl } from "@/common/helpers/taxonomy.util";
import { ProductDetailsSection } from "./components/ProductDetailsSection/product-details-section";
import { ProductAbout } from "./components/ProductAbout/product-about";
import { useGetHardwareDetails } from "@/pages/hardware-details/hooks/use-get-hardware-details.hook";
import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

const HardwareDetailsPage: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const taxonomyId = parseTaxonomyIdFromUrl(location.pathname);

  const { item, isLoading, error, defaultVersion, versions, updateVersionSelected, getItem } =
    useGetHardwareDetails();

  useEffect(() => {
    getItem(taxonomyId);
  }, [taxonomyId]);

  if (isLoading) {
    return (
      <PageContainer paddingHorizontal={0} paddingTop={0} isFullWidth={true}>
        <View padding="S700">
          <Spinner size={SpinnerSize.Medium} />
        </View>
      </PageContainer>
    );
  }

  if (error) {
    return (
      <PageContainer paddingHorizontal={0} paddingTop={0} isFullWidth={true}>
        <View padding="S700">
          <Text color="error70" data-testid="error-message">
            {error.message}
          </Text>
        </View>
      </PageContainer>
    );
  }

  if (!item) return null;

  const parentItemName = item.parentName ?? item.name;
  const priceAmount = defaultVersion?.amount ?? item.priceAmount;
  const priceCurrency = defaultVersion?.currency ?? item.priceCurrency;

  const handleCrumbClick: CrumbClickFunc = (event, crumb) => {
    event.preventDefault();
    if (crumb.url) history.push(crumb.url);
  };

  return (
    <>
      <PageMainContainer>
        <Breadcrumbs
          crumbs={[
            { title: "Home", url: "/" },
            { title: "Hardware", url: "/" },
            { title: parentItemName },
          ]}
          onCrumbClick={handleCrumbClick}
        />
      </PageMainContainer>

      <ProductDetailsSection
        item={item}
        parentItemName={parentItemName}
        priceAmount={priceAmount}
        priceCurrency={priceCurrency}
        versions={versions}
        defaultVersion={defaultVersion}
        updateVersionSelected={updateVersionSelected}
      />

      <ProductAbout description={item.description} />
    </>
  );
};

export default HardwareDetailsPage;
